import PropTypes from 'prop-types';

function MMMeatAndSeafoodActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11287)">
                <path
                    d="M27.5947 7.05007C27.6435 6.3277 27.7747 3.48674 25.7111 2.18181C23.6475 0.876888 17.4311 0.451999 13.4541 2.95341C9.477 5.45483 9.86426 10.2763 12.4772 12.9874C14.4866 15.0928 16.8287 16.8532 19.4098 18.198C22.3926 19.7983 25.5839 20.8024 27.1827 20.3077C28.7815 19.813 30.9388 18.4789 29.8775 15.4097C29.4135 14.3488 28.3026 13.6252 27.7234 12.4474C27.1442 11.2696 27.4548 9.01584 27.5947 7.05007Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25.8464 8.71008C25.8954 8.12523 26.5462 4.85534 24.7502 3.66104C22.9541 2.46675 17.5851 2.43804 14.4879 4.20291C11.3908 5.96779 11.7468 9.92127 14.0879 12.3022C16.4291 14.6832 18.3509 15.7414 20.0779 16.757C22.6534 18.2591 24.6592 18.9199 26.1041 18.8012C27.401 18.6921 29.1233 17.7472 28.2761 15.6138C27.9009 14.6777 26.8716 14.0563 26.3104 13.0567C25.7491 12.0571 25.6946 10.5125 25.8464 8.71008Z"
                    fill="#DC6C31"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M22.2601 5.68413C23.6267 5.43134 23.901 6.838 22.9168 7.12584C21.0997 7.66001 20.3115 7.72691 19.8531 7.92688C19.2727 8.17989 18.8823 9.17573 22.3093 12.7319C23.7753 14.253 25.1695 15.5487 24.4719 16.1606C23.9386 16.6308 22.3593 15.1418 20.493 13.1088C17.4867 9.82575 18.3703 8.95112 17.4068 8.83901C16.4434 8.7269 14.5411 9.62318 14.2112 8.48398C14.0296 7.82639 14.4769 7.60443 16.9577 6.87597C18.7013 6.37906 20.4716 5.98114 22.2601 5.68413V5.68413Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.60847 13.4984C3.25312 13.0364 8.19981 10.6204 12.4084 12.8296C16.617 15.0389 18.301 17.6455 19.5053 21.5908C21.7592 20.8253 23.8723 20.8032 26.079 23.4272C24.6814 22.9838 22.3915 24.2306 21.6014 25.4432C20.6527 26.8764 20.9157 28.4966 21.8254 30.2815C19.565 29.8167 16.8902 28.4308 17.4613 25.047C15.5999 25.9506 13.5076 26.2663 11.4625 25.9523C9.41729 25.6383 7.51607 24.7095 6.01139 23.2892C1.58734 19.1834 2.60847 13.4984 2.60847 13.4984Z"
                    fill="#F1C34B"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.63587 11.9843C10.564 11.705 11.5057 11.4728 12.4573 11.2883C14.0119 10.9824 16.1631 12.257 17.47 13.4848C18.777 14.7126 19.6309 15.6923 19.7032 16.151C19.7755 16.6097 18.7233 19.1077 18.7233 19.1077C18.7233 19.1077 16.8635 15.3451 14.1929 13.8892C12.7552 13.075 11.2253 12.4355 9.63587 11.9843V11.9843Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.26751 21.2002C4.70075 21.1445 7.2731 21.1129 9.67305 18.473C12.073 15.8332 11.1114 12.4642 11.1114 12.4642C11.1114 12.4642 7.29435 10.8993 2.60845 13.4982C1.93419 17.5709 4.26751 21.2002 4.26751 21.2002Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.46362 15.363C7.80721 15.4027 8.11793 15.1564 8.15763 14.8128C8.19734 14.4692 7.95099 14.1585 7.60741 14.1188C7.26382 14.0791 6.9531 14.3254 6.9134 14.669C6.87369 15.0126 7.12004 15.3233 7.46362 15.363Z"
                    fill="#F1C34B"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.9992 16.1478C10.9992 16.1478 13.0455 17.0421 13.3732 20.3731C10.2717 21.765 8.17976 19.8081 8.17976 19.8081C8.17976 19.8081 9.5898 19.466 10.9992 16.1478Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.7678 18.4215C16.4071 18.9888 15.6581 20.3197 14.959 20.1684C15.4853 20.8323 14.7912 22.1969 13.8406 22.0871C13.9434 22.2599 13.9958 22.4581 13.9918 22.6591C13.9879 22.8602 13.9277 23.0561 13.8182 23.2248C13.7087 23.3934 13.5541 23.5281 13.372 23.6134C13.19 23.6988 12.9876 23.7316 12.7879 23.7079"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.9593 20.4468C17.5657 20.9593 16.8496 22.345 15.9797 22.1465C16.3833 22.8902 15.8207 23.9294 14.9271 23.7674"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11287">
                    <rect width="30" height="30" fill="white" transform="translate(0.780762 0.303711)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMMeatAndSeafoodActive;

MMMeatAndSeafoodActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMMeatAndSeafoodActive.defaultProps = {
    className: null,
};
